import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { CloseIcon } from "components/icons";
import { Feature, LineString } from "geojson";
import useToggle from "hooks/use-toggle";
import { Dispatch, SetStateAction } from "react";
import { Restriction } from "types";

type RemoveRestrictionParam = {
  id: string;
};

type SelectedMultipleCurbZoneDetailProps = {
  curbZoneRestrictions: Feature<LineString, Restriction>[];
  resetState: () => void;
  openCurbZoneMultiModal: Dispatch<SetStateAction<boolean>>;
  handleRemoveMultipleCurbZoneRestrictions: (input: RemoveRestrictionParam[]) => void;
};

export const SelectedMultipleCurbZoneRestrictionDetail = ({
  curbZoneRestrictions,
  resetState,
  openCurbZoneMultiModal,
  handleRemoveMultipleCurbZoneRestrictions,
}: SelectedMultipleCurbZoneDetailProps) => {
  const [openConfirm, setOpenConfirm] = useToggle(false);
  const removeMultiCurbZoneRestriction = () => {
    const curbZoneRestrictionsIds = curbZoneRestrictions.map(({ properties }) => ({
      id: properties.id,
    }));
    handleRemoveMultipleCurbZoneRestrictions(curbZoneRestrictionsIds);
    resetState();
  };

  return (
    <>
      <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-10 w-64">
        <div className="flex justify-end h-6 cursor-pointer">
          <CloseIcon className="text-white w-4 h-4" onClick={resetState} />
        </div>
        <div className="flex gap-8 py-2">
          <span className="text-sm text-secondary">Currently selecting</span>
          <span className="text-sm text-secondary text-right">{curbZoneRestrictions?.length} Restrictions</span>
        </div>
        <div className="flex justify-between">
          <Button onClick={setOpenConfirm} variant="destructive">
            Delete
          </Button>
          <Button onClick={() => openCurbZoneMultiModal(true)} variant="secondary">
            Edit
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete restrictions</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete the restrictions?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={setOpenConfirm}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={removeMultiCurbZoneRestriction}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
